import { userService } from '@/services'

let initialState = {
  printMode: null,
  colorMode: null,
  frankingType: null,
  confirmProductionArea: null,
  confirmFontWarnings: null,
  daysUntilDataCleaning: null,
  orderSchedule: { type: null, dayOfWeek: null, date: null },
  merge: null,
  defaultCostCenter: null,
  foldType: null,
  locked: null,
  emailSettings: null,
  duplicateCheckEnabled: null,
  duplicateCheckPeriodInDays: null
}

export default {
  state: () => initialState,
  mutations: {
    SET_USER_SETTINGS(state, settings) {
      state.printMode = settings.printMode
      state.colorMode = settings.colorMode
      state.frankingType = settings.frankingType
      state.confirmProductionArea = settings.confirmProductionArea
      state.confirmFontWarnings = settings.confirmFontWarnings
      state.daysUntilDataCleaning = settings.daysUntilDataCleaning
      state.orderSchedule = settings.orderSchedule
      state.merge = settings.merge
      state.defaultCostCenter = settings.defaultCostCenter
      state.foldType = settings.foldType
      state.locked = settings.locked
      state.emailSettings = settings.emailSettings
      state.duplicateCheckEnabled = settings.duplicateCheckEnabled
      state.duplicateCheckPeriodInDays = settings.duplicateCheckPeriodInDays
    },
    RESET(state) {
      const s = initialState
      Object.keys(s).forEach(key => {
        state[key] = s[key]
      })
    }
  },
  actions: {
    async getUserSettings({ dispatch }) {
      await userService.getUserSettings().then(async function(response) {
        await dispatch('setUserSettings', response)
      })
    },
    async saveUserSettings({ dispatch, state }, userSettings) {
      // clone state for userService
      let cState = { ...state }
      // assign values
      Object.keys(userSettings).map(setting => {
        cState[setting] = userSettings[setting]
      })
      await userService.saveUserSettings(cState).then(async function(response) {
        await dispatch('setUserSettings', response)
      })
    },
    setUserSettings({ commit }, userSettings) {
      commit('SET_USER_SETTINGS', userSettings)
    }
  },
  getters: {
    isLocked: state => {
      return state.locked
    },
    orderSchedule: state => {
      return state.orderSchedule
    }
  }
}
